/*eslint-disable*/
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Typography,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Icon,
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React, { Fragment } from "react";
import { Field, change } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { dateValid, isEmptyOrSpaces } from "helpers/ValidationHelpers";
import { ParseDMYwSlashes } from "helpers/DateHelpers";
import GetIdInformation, { idNumberValid } from "helpers/GetIdInformation";
import moment from "moment";
import DescriptiveCell from "../components/DescriptiveCell.jsx";
import "./PersonalDetail.css"

const required = value => (value ? undefined : "Required");
const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const CustomFieldMed = props => (
	<GridItem xs={6} sm={6} md={6} style={{ marginTop: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

const CustomField2 = props => (
  <GridItem xs={6} sm={6} md={6} style={{ marginTop: '25px' }}>
    <FormControl fullWidth >
      <Field {...props} />
    </FormControl>
  </GridItem>

);

const CustomFieldFullWidth = props => (
	<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

const CustomFieldN = props => (
	
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	
);

const checkItem = (label, name, changeFunc) => {
  return (
    
    <GridItem xs={4} sm={4} md={2} >
            <FormControl style={{marginBottom: "-27px", paddingBottom: "-27px"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(h, f)

                }}

              />
            </FormControl>
            </GridItem>
  );
};


class PersonalDetail extends React.Component {
  componentDidMount() 
  {
    this.props.scrollMeBar();
  }

  changeReason(name)
  {
    var reasons = this.props.fnaReasons;
    reasons[name] = !reasons[name];
    console.log(reasons)
    this.props.changePersonal("fnaReasons", reasons)

  }

 

  render()
  {
    var clientD = "";
   /* if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname*/
    return(
      <div className="contentWithStepper">
       
        <Card
        style={{ width: "120%", marginLeft:"-10%" }}
        >
          <CardContent>
            <CustomCardHeading
              subheading={"Business Needs Analysis"}
              caption={clientD}
              headline={"Business Details"}
            />

            <Grid container>
              
                  <CustomFieldMed
                    name={'description'}
                    component={FormInput}
                    checkValidation={this.props.checkValidation}
                    label={'Business Needs Analysis for: '}
                    isrequired={true}
                    //validate={[required]}
                  />
                  </Grid>
<Grid container>
                   <CustomFieldMed
                        name={'companyName'}
                        component={FormInput}
                        checkValidation={this.props.checkValidation}
                        label={'Registered Name'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />

                      <CustomFieldMed
                        name={'companyRegNr'}
                        component={FormInput}
                        checkValidation={this.props.checkValidation}
                        label={'Registration Number'}
                        isrequired={true}
                        //validate={[required]}
                        onChange = {(e, f, g, h) => 
                          {
                            this.props.changePersonal(h,f)
                          }}
                      />

                       <CustomField2
                            name={"entityType"}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={'Entity Type'}
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              [
                                {
                                  displayValue: "Company",
                                  value: "company",
                                  limit: 1
                                },
                                {
                                  displayValue: "Closed Corporation",
                                  value: "cc",
                                  limit: 1
                                },
                                {
                                  displayValue: "Trust",
                                  value: "trust",
                                  limit: 1
                                },
                                {
                                  displayValue: "Partnership",
                                  value: "partnership",
                                  limit: 1
                                },
                                {
                                  displayValue: "Sole Proprietor",
                                  value: "soleProtrietor",
                                  limit: 1
                                },
                                {
                                  displayValue: "Individual",
                                  value: "individual",
                                  limit: 1
                                },
                              ]
                            }
                            onChange={(e, value, t, name) => this.changePersonal(value, name)}
                            
                            
                          />

                      <CustomFieldMed
                        name={'marketValue'}
                        prefix="R"
                        component={NumberInput}
                        checkValidation={this.props.checkValidation}
                        label={'Company Market Value'}
                        isrequired={true}
                        //validate={[required]}
                        onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                      />
 <Grid container>
                      <CustomField2
                            name={"buySell"}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={'Buy and Sell'}
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              [
                                {
                                  displayValue: "Traditional",
                                  value: "traditional",
                                  limit: 1
                                },
                                {
                                  displayValue: "Alternative",
                                  value: "alterantive",
                                  limit: 1
                                },
                                {
                                  displayValue: "Share Buy Back",
                                  value: "shareBuyBack",
                                  limit: 1
                                },
                                
                              ]
                            }
                            onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            
                            
                          />

</Grid>

                    <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                    <Grid container>
             
                   
                    </Grid>
                    </GridItem>

                    
              
            </Grid>

            <ExpansionPanel defaultExpanded={0 === 1} key={101}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        <Typography style={{ fontSize: '16px' , fontWeight:"420"}}>
        {"Business Owner/s:"}
          </Typography>
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                      
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                          rowSpan={2}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Type Of Entity</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                          rowSpan={2}
                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Full names and surname / Entity Name
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                          rowSpan={2}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                          ID number/Reg.no.
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                          rowSpan={2}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Percentage ownership</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                          rowSpan={2}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Loan Account</Typography>
                        </TableCell>

                        

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("12em")}
                          colSpan={2}
                          rowSpan={1}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Insured Life</Typography>
                          </TableCell> 


                      </TableRow>
                      <TableRow>
                      <TableCell
                          className="cellPaddingTiny"
                          id = "doubleLine"
                          style={{colwidth: "6em"}}
                          
                          
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Full names and surname</Typography>
                        </TableCell>

                          <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                          
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>ID number</Typography>
                        </TableCell>
                    </TableRow>

                    </TableHead>
                    <TableBody>

                    {this.props.state.businessOwners.map((e, i) => 
                  {
                    console.log(e)
                    if(e.isOwner === true)
                    return (
                      <TableRow>
                        <TableCell style={{ paddingRight: '0px' }}>
                          <Button
                              name={"remove" + i}
                              key = {"remove" + i}
                              variant="fab"
                              mini
                              className="minifab"
                              color="primary"
                              style={{ left: "-20px", top: "0px"}}
                              onClick={(e) =>{e.stopPropagation(); this.props.removeOwner(e)}}
                            >
                              <Icon style={{ color: "white" }}>remove</Icon>
                            </Button>
                            <CustomFieldN
                              name={"businessOwners.type-" + i}
                              component={FormDropdown}
                              checkValidation={this.props.checkValidation}
                              label={''}
                             
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              [
                                {
                                  displayValue: "Company",
                                  value: "company",
                                  limit: 1
                                },
                                {
                                  displayValue: "Closed Corporation",
                                  value: "cc",
                                  limit: 1
                                },
                                {
                                  displayValue: "Trust",
                                  value: "trust",
                                  limit: 1
                                },
                                {
                                  displayValue: "Partnership",
                                  value: "partnership",
                                  limit: 1
                                },
                                {
                                  displayValue: "Sole Proprietor",
                                  value: "soleProtrietor",
                                  limit: 1
                                },
                                {
                                  displayValue: "Individual",
                                  value: "individual",
                                  limit: 1
                                },
                              ]
                            }
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell >
                          
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'businessOwners.name-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                            <CustomFieldN
                              name={'businessOwners.id-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'ID'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                        <CustomFieldN
                              
                              name={'businessOwners.ownership-' + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'%'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                            <CustomFieldN
                              
                              name={'businessOwners.loan-' + i}
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R'}
                              isrequired={false}
                              prefix = "R"
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>
                        {
                          e.type !== "individual" && 
                          <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                            <CustomFieldN
                              name={'businessOwners.insuredName-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>
                        }

{
                          e.type !== "individual" && 
                          <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                            name={'businessOwners.insuredId-' + i}
                            component={FormInput}
                            checkValidation={this.props.checkValidation}
                            label={'ID'}
                            isrequired={false}
                            
                            onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                          />
                      </TableCell>
                        }


                        
                      </TableRow>
                    )
                  })}

                      <TableRow>


                      <TableCell
                      colSpan={2}>

                      <DescriptiveCell
                          
                          width="150em"
                          description={"Add Owner"}
                          add={() =>
                            this.props.addOwner()
                          }


                        />
                      </TableCell>
                        


                       


                      </TableRow>

                    </TableBody>
                  </Table>

                  

                </Grid>

              </ExpansionPanelDetails>
            </ExpansionPanel>


            <ExpansionPanel defaultExpanded={0 === 1} key={102}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        <Typography style={{ fontSize: '16px' , fontWeight:"420"}}>
        {"Other Purchaser/s:"}
          </Typography>
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                      
                        
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("48em")}
                          
                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Full names and surname / Entity Name
                          </Typography>

                        </TableCell>
                        
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("48em")}
                         

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>ID number/Regno</Typography>

                        </TableCell>
                       


                      </TableRow>
                     

                    </TableHead>
                    <TableBody>

                    {this.props.state.businessOwners.map((e, i) => 
                  {
                    if(!e.isOwner)
                    return (
                      <TableRow>
                        <TableCell style={{ paddingRight: '0px' }}>
                          <Button
                              name={"remove" + i}
                              key = {"remove" + i}
                              variant="fab"
                              mini
                              className="minifab"
                              color="primary"
                              style={{ left: "-20px", top: "0px"}}
                              onClick={(e) =>{e.stopPropagation(); this.props.removeOwner(e)}}
                            >
                              <Icon style={{ color: "white" }}>remove</Icon>
                            </Button>
                            <CustomFieldN
                              name={'businessOwners.name-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell >
                          
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'businessOwners.id-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'ID/Regno'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>

                        
                        
                       
                      </TableRow>
                    )
                  })}

                      <TableRow>
                  

                        <TableCell
                         width="12em"
                        ><Typography variant="title">

                        <DescriptiveCell
                          width="12em"
                          description={"Add Purchaser"}
                          add={() =>
                            this.props.addPurchaser()
                          }


                        />
                          
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                  

                </Grid>

              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel defaultExpanded={0 === 1} key={103}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        <Typography style={{ fontSize: '16px' , fontWeight:"420"}}>
        {"Heir/s:"}
          </Typography>
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                      
                        
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("48em")}
                          
                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Full names and surname / Entity Name
                          </Typography>

                        </TableCell>
                        
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("48em")}
                         

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>ID number/Regno</Typography>

                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Heir to</Typography>
                          
                        </TableCell>

                        <TableCell>
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Inherit Amount</Typography>
                        </TableCell>
                       


                      </TableRow>
                     

                    </TableHead>
                    <TableBody>

                    {this.props.state.heirs.map((e, i) => 
                  {
                    var owners = 
                    [
                      {
                        displayValue: "Please Select",
                        value: "",
                        limit: 1
                      }
                    ]
                    this.props.state.businessOwners.map((e, i) =>
                      {
                        owners.push(
                          {
                            displayValue: e.name,
                            value: e.name,
                            limit: 1
                          }
                        )
                      })
                    return (
                      <TableRow>
                        <TableCell style={{ paddingRight: '0px' }}>
                          <Button
                              name={"remove" + i}
                              key = {"remove" + i}
                              variant="fab"
                              mini
                              className="minifab"
                              color="primary"
                              style={{ left: "-20px", top: "0px"}}
                              onClick={(e) =>{e.stopPropagation(); this.props.removeEntity(e, "heirs")}}
                            >
                              <Icon style={{ color: "white" }}>remove</Icon>
                            </Button>
                            <CustomFieldN
                              name={'heirs.name-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changeHeir(value, name)}
                            />
                        </TableCell >
                          
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'heirs.id-' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'ID/Regno'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changeHeir(value, name)}
                            />
                        </TableCell>

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                        <CustomFieldN
                            name={"heirs.to-" + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              owners
                            }
                            onChange={(e, value, t, name) => this.props.changeHeir(value, name)}
                            
                            
                          />
                        </TableCell>


                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              
                              name={'heirs.inherit-' + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'%'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changeHeir(value, name)}
                            />


                        </TableCell>
                        

                        
                        
                        
                       
                      </TableRow>
                    )
                  })}

                      <TableRow>
                  

                        <TableCell
                         width="12em"
                        ><Typography variant="title">

                        <DescriptiveCell
                          width="12em"
                          description={"Add Heir"}
                          add={() =>
                            this.props.addHeir()
                          }


                        />
                          
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                  

                </Grid>

              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel defaultExpanded={0 === 1} key={104}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        <Typography style={{ fontSize: '16px' , fontWeight:"420"}}>
        {"Key persons:"}
          </Typography>
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                      
                        
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("48em")}
                          
                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Full names and surname / Entity Name
                          </Typography>

                        </TableCell>
                        
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("48em")}
                         

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>ID number/Regno</Typography>

                        </TableCell>
                       


                      </TableRow>
                     

                    </TableHead>
                    <TableBody>

                    {this.props.state.keyPersons.map((e, i) => 
                  {
                    return (
                      <TableRow>
                        <TableCell style={{ paddingRight: '0px' }}>
                          <Button
                              name={"remove" + i}
                              key = {"remove" + i}
                              variant="fab"
                              mini
                              className="minifab"
                              color="primary"
                              style={{ left: "-20px", top: "0px"}}
                              onClick={(e) =>{e.stopPropagation(); this.props.removeEntity(e, "keyPersons")}}
                            >
                              <Icon style={{ color: "white" }}>remove</Icon>
                            </Button>
                            <CustomFieldN
                              name={'keyPersons.name' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell >
                          
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'keyPersons.id' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'ID/Regno'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>

                        

                        
                        
                       
                      </TableRow>
                    )
                  })}

                      <TableRow>
                  

                        <TableCell
                         width="12em"
                        ><Typography variant="title">

                        <DescriptiveCell
                          width="12em"
                          description={"Add Key Person"}
                          add={() =>
                            this.props.addKeyPerson()
                          }


                        />
                          
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                  

                </Grid>

              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel defaultExpanded={0 === 1} key={105}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        <Typography style={{ fontSize: '16px' , fontWeight:"420"}}>
        {"Surety:"}
          </Typography>
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                    
                      <TableRow>
                      
                        
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("48em")}
                          
                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Full names and surname / Entity Name
                          </Typography>

                        </TableCell>
                        
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("48em")}
                         

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>ID number/Regno</Typography>

                        </TableCell>
                       


                      </TableRow>
                     

                    </TableHead>
                    <TableBody>

                    {this.props.state.sureties.map((e, i) => 
                  {
                    return (
                      <TableRow>
                        <TableCell style={{ paddingRight: '0px' }}>
                          <Button
                              name={"remove" + i}
                              key = {"remove" + i}
                              variant="fab"
                              mini
                              className="minifab"
                              color="primary"
                              style={{ left: "-20px", top: "0px"}}
                              onClick={(e) =>{e.stopPropagation(); this.props.removeEntity(e, "sureties")}}
                            >
                              <Icon style={{ color: "white" }}>remove</Icon>
                            </Button>
                            <CustomFieldN
                              name={'sureties.name' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'Name'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell >
                          
                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'sureties.id' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'ID/Regno'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                        </TableCell>

                        
                        
                       
                      </TableRow>
                    )
                  })}

                      <TableRow>
                  

                        <TableCell
                         width="12em"
                        ><Typography variant="title">

                        <DescriptiveCell
                          width="12em"
                          description={"Add Surety"}
                          add={() =>
                            this.props.addSurety()
                          }


                        />
                          
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                  

                </Grid>

              </ExpansionPanelDetails>
            </ExpansionPanel>
          </CardContent>
        </Card>

       

      </div>

    );
  }
}

export default PersonalDetail;



// WEBPACK FOOTER //
// ./src/views/Bna/steps/PersonalDetail.jsx